

import BaseComponent from "../BaseComponent.vue";
import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import _ from 'lodash';

@Component
//export default class LoginCallback extends BaseComponent {
export default class LoginCallback extends Vue {
  async beforeMount () {
    const self = this as any;
    try
    {
      await self.$auth.handleAuthentication();
      // self.$router.replace({
      //   path: self.$auth.getFromUri() + '/ttt'
      // })
      self.$router.push({ name: 'main', params: { okta_login: true } });
    }
    catch (ex) {
      self.$router.push({ name: 'main', params: { okta_login_error: ex } });
    }
  }
  render () {}
}

